module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 1006
// module chunks = 4